(function () {
  const STORAGE_KEY = "19keys:funnel-events";
  const MAX_EVENTS = 80;

  function readEvents() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch (_error) {
      return [];
    }
  }

  function safeFormData(form) {
    const formData = new FormData(form);
    const payload = {};
    for (const [key, value] of formData.entries()) {
      const normalizedKey = key.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
      if (/email|phone|name/.test(normalizedKey)) {
        payload[`has_${normalizedKey}`] = Boolean(String(value).trim());
      } else if (payload[key]) {
        payload[key] = Array.isArray(payload[key]) ? payload[key].concat(value) : [payload[key], value];
      } else {
        payload[key] = value;
      }
    }
    return payload;
  }

  function elementLabel(element) {
    return (element.getAttribute("aria-label") || element.textContent || element.name || element.id || "").trim().replace(/\s+/g, " ");
  }

  function record(element, interaction, details) {
    const successEvent = element && (element.dataset.successEvent || element.dataset.track);
    if (!element || !successEvent) return;
    const entry = {
      id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
      timestamp: new Date().toISOString(),
      page: window.location.pathname.split("/").pop() || "index.html",
      world_id: element.dataset.worldId || document.body.dataset.worldId || "unknown",
      route_id: element.dataset.routeId || element.dataset.track || "unmapped",
      success_event: successEvent,
      interaction,
      label: elementLabel(element),
      destination: element.getAttribute("href") || element.getAttribute("action") || element.dataset.destination || "local-prototype",
      connector_id: element.dataset.connectorId || "",
      connector_action: element.dataset.connectorAction || "",
      connector_adapter: element.dataset.connectorAdapter || "",
      capture_status: element.dataset.captureStatus || "",
      crm_segment_key: element.dataset.crmSegmentKey || "",
      sms_segment_key: element.dataset.smsSegmentKey || "",
      details: details || {},
    };
    const events = readEvents().concat(entry).slice(-MAX_EVENTS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
    document.documentElement.dataset.funnelEventsReady = "true";
    document.documentElement.dataset.lastFunnelEvent = entry.success_event;
    document.documentElement.dataset.lastFunnelRoute = entry.route_id;
    window.dispatchEvent(new CustomEvent("19keys:funnel-event", { detail: entry }));
  }

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target.closest("[data-success-event], [data-track]");
      if (target && target.tagName !== "FORM" && target.dataset.funnelTrigger !== "input") {
        record(target, "click");
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target.closest("form[data-success-event], form[data-track], form[data-capture-form], form.sm-capture-form, form.sm-open__form");
      if (form) {
        record(form, "submit", safeFormData(form));
      }
    },
    true
  );

  document.addEventListener("input", (event) => {
    const target = event.target.closest("[data-success-event][data-funnel-trigger='input']");
    if (target) {
      record(target, "input", { value: target.value });
    }
  });

  window.__19keysFunnelEvents = {
    clear: () => localStorage.removeItem(STORAGE_KEY),
    read: readEvents,
    record,
  };
  document.documentElement.dataset.funnelEventsReady = "true";

  if (document.body && document.body.dataset.worldId) {
    const routeTarget = document.body;
    if (!routeTarget.dataset.successEvent) routeTarget.dataset.successEvent = "route_view";
    if (!routeTarget.dataset.routeId) routeTarget.dataset.routeId = routeTarget.dataset.comp || window.location.pathname || "route";
    record(routeTarget, "view", { title: document.title });
  }
})();
